import React, { useState } from "react";
import {
  Grid,
  Stack,
  Typography,
  Box,
  Button,
} from "@mui/material";
import useMediaQuery from '@mui/material/useMediaQuery';
import help1 from "./../images/help1.jpeg";
import help2 from "./../images/help2.jpeg";
import help3 from "./../images/help3.jpeg";
import help4 from "./../images/help4.jpeg";
import help5 from "./../images/help5.jpeg";
import help7 from "./../images/help7.jpeg";
import help8 from "./../images/help8.jpeg";
import help9 from "./../images/help9.jpeg";
import help10 from "./../images/help10.jpeg";
import help13 from "./../images/help13.jpeg";
import help12 from "./../images/help12.jpeg";
import help6 from "./../images/help6.jpeg";
import help11 from "./../images/help11.jpeg";
import FormModal from "./FormModal";



const HelptoTalk = () => {
  const [open, setOpen] = useState(false);
  const vMediaQuery = useMediaQuery('(max-width:600px)');

  const teamsMeetingLink = "https://teams.microsoft.com/l/call/0/?users=hr@gdrdynamics.com";


  const btnStyle = {
    color: "white",
    fontWeight: 600,
    borderRadius: "30px",
    padding: vMediaQuery ? "8px 16px" : "12px 16px",
    background: "linear-gradient(45deg, #42d1f5, #357ec7)",
    textTransform: "none",
    "&:hover": {
      background: "linear-gradient(45deg, #357ec7, #42d1f5)",
      color: "white",
      borderRadius: "30px",
      textDecoration: "underline",
    },
  }

  const linkBtn = {
    color: "white",
    padding: "0px 6px 0px 0px",
    textDecoration: "none",
    fontSize: vMediaQuery ? "14px" : "14px",
    textTransform: "none",
    "&:hover": {
      textDecoration: "underline",
      background: "none",
    },
  }

  const handleOpen = () => {
    setOpen(true);

    setTimeout(() => {
      document.getElementById('from_firstname')?.focus();
    }, 400);
  };
  const handleClose = () => setOpen(false);


  return (
    <>
      {vMediaQuery &&
        <Box sx={{ padding: vMediaQuery ? "40px 16px" : "60px 140px", textAlign: "center" }}>
          <Typography variant="h4" color="#707070" sx={{ fontFamily: "EB Garamond", fontSize: vMediaQuery ? "26px" : "32px", padding: "16px", }}>
            We help you to {" "}
            <strong style={{ color: "green", fontFamily: "EB Garamond", }}> grow your business big</strong>
          </Typography>
          {vMediaQuery ||
            <Typography variant="subtitle1">At GDR Consultancy, we help you execute digital transformation in your  organization <br /> by optimizing the solutions offered by Microsoft...</Typography>
          }
          <div className="CallBtn">
            <Button sx={btnStyle} onClick={handleOpen}>  Talk to us now!</Button>
          </div>
        </Box>
      }
      {vMediaQuery ||
        <Box
          sx={{
            flexGlow: 1,
            padding: vMediaQuery ? "30px 16px" : "0px 0px 10px 0px",
            textAlign: "center",
            backgroundColor: "#f5f5f5",
          }}
        >

          <div>
            <Stack direction={"row"} spacing={56} sx={{ justifyContent: "flex-end" }}>
              <div className="help-contanier">
                <img className="helpImg1" alt="certificates" src={help1} />
              </div>
              <div className="help-contanier">
                <img className="helpImg2" alt="certificates" src={help2} />
              </div>
            </Stack>
            <Stack direction={"row"} spacing={0} sx={{ textAlign: "center", justifyContent: "center" }}>
              <div className="help-contanier">
                <img className="helpImg3" alt="certificates" src={help3} />
              </div>
              <div className="help-contanier">
                <img className="helpImg4" alt="certificates" src={help4} />
              </div>
              <div className="help-contanier">
                <img className="helpImg8" alt="certificates" src={help5} />
              </div>
            </Stack>
            <Grid container>
              <Grid item xs={3.5} >
                <div className="help-contanier">
                  <img className="helpImg7" alt="certificates" src={help7} />
                </div>
                <div className="help-contanier">
                  <img className="helpImg5" alt="certificates" src={help8} />
                </div>
                <div className="help-contanier" style={{ marginTop: "20px" }}>
                  <img className="helpImg6" alt="certificates" src={help10} />
                </div>
              </Grid>
              <Grid item xs={5} >
                <Typography variant="h4" color="#707070" sx={{ fontFamily: "EB Garamond", fontSize: vMediaQuery ? "26px" : "34px", padding: "16px" }}>
                  We help you to {" "}
                  <strong style={{ color: "green", fontFamily: "EB Garamond", }}> grow your business big</strong>
                </Typography>
                {vMediaQuery ||
                  <Typography variant="subtitle1">At GDR Consultancy, we help you execute digital transformation in your  organization <br /> by optimizing the solutions offered by Microsoft...</Typography>
                }
                <div className="CallBtn">
                  <Button sx={btnStyle} onClick={handleOpen} >Schedule a Appointment</Button>
                </div>
              </Grid>
              <Grid item xs={3.5} >
                <div className="help-contanier7">
                  <img className="helpImg7" alt="certificates" src={help6} />
                </div>
                <div className="help-contanier7">
                  <img className="helpImg9" alt="certificates" src={help9} />
                </div>
                <div className="help-contanier7">
                  <img className="helpImgTen" alt="certificates" src={help11} />
                </div>
              </Grid>
            </Grid>
            <Stack direction={"row"} spacing={0} sx={{ justifyContent: "center", textAlign: "center", alignItems: "center" }}>
              <div className="help-contanier">
                <img className="helpImgTh" alt="certificates" src={help13} />
              </div>
              <div className="help-contanier">
                <img className="helpImgTht" alt="certificates" src={help12} />
              </div>
            </Stack>
          </div>
        </Box>
      }

      <FormModal open={open} handleClose={handleClose} />
    </>
  );
};

export default HelptoTalk;
